import "reflect-metadata"; // must be first
import { RtfDisplayModule } from './modules/rtf-display/rtf-display.module';
import { CommonModule } from './modules/common.module';
import { ExtensionContext } from "./common/models/extension-config";
import { ClassProvider, container, DependencyContainer, InjectionToken, Lifecycle } from "tsyringe";
import { Module } from './common/module';
import { ExtensionOperationsModule } from './modules/extension-operations.module';
import { EnrichedContextModule } from './modules/enriched-context.module';
import { ElementsIntegrationModule } from "./modules/elements-integration.module";
import { DashboardTooltipButtonManagerModule } from "./modules/common/dashboard-tooltip-button-manager.module";
import { UrlChangeListenerModule } from "./modules/common/url-change-listener.module";
import { ApiModule } from "./modules/common/api/api.module";
import { ExportPdfModule } from "./modules/export-pdf.module";


// register the services here
function registerServices() {
    container.register<ElementsIntegrationModule>(ElementsIntegrationModule, { useClass: ElementsIntegrationModule }, { lifecycle: Lifecycle.Singleton });
    // register modules here with Module tag
    // if (licenseFlags.includes("test")) {
    //     container.register<myModule>('module', { useClass: myModule});
    // }
    container.register<CommonModule>('module', { useClass: CommonModule }, { lifecycle: Lifecycle.Singleton });
    container.register<ApiModule>('module', { useClass: ApiModule }, { lifecycle: Lifecycle.Singleton });
    container.register<DashboardTooltipButtonManagerModule>('module', { useClass: DashboardTooltipButtonManagerModule}, { lifecycle: Lifecycle.Singleton });
    container.register<UrlChangeListenerModule>('module', { useClass: UrlChangeListenerModule}, { lifecycle: Lifecycle.Singleton });
    container.register<EnrichedContextModule>('module', { useClass: EnrichedContextModule }, { lifecycle: Lifecycle.Singleton });
    container.register<ExtensionOperationsModule>('module', {useClass: ExtensionOperationsModule}, { lifecycle: Lifecycle.Singleton });
    container.register<RtfDisplayModule>('module', { useClass: RtfDisplayModule }, { lifecycle: Lifecycle.Singleton });
    container.register<ExportPdfModule>('module', { useClass: ExportPdfModule }, { lifecycle: Lifecycle.Singleton });

}




async function init() {
    // init the integration module first
    const integrationModule = container.resolve<ElementsIntegrationModule>(ElementsIntegrationModule);
    integrationModule.run();
    console.log('Integration module ran')

    // init all other modules dynamically
    const modules = container.resolveAll<Module>('module');
    const initedModules: string[] = [integrationModule.name];
    for (let m of modules) {
        if ((m.acceptedLicenseFlags.length === 0 || integrationModule.config.licenseFlags.some(lf => m.acceptedLicenseFlags.includes(lf))) && m.shouldRun(integrationModule.config.context)) {
            console.log('Running module: ' + m.name)
            await initModule(m, initedModules);
        }
    }
    window.elementsIntegration.modules = modules;


}

async function initModule(module: Module, initedModules: string[]): Promise<void> {
    for (let subModule of module.dependantModules ?? []) {
        await initModule(subModule, initedModules);
    }
    
    if (!initedModules.includes(module.name)) {
        initedModules.push(module.name);
        try {
            console.log(module.name);
            await module.run();
        } catch (e) {
            console.error('Module threw an error');
            console.error(e);
        }
       
    }
}
registerServices();
init();
